import { createContext } from 'react';

const WeatherContext = createContext();

export default WeatherContext;
